/// <summary>
/// This visual provides a list of user notifications<br/>
/// </summary>    ///
/// <remarks>
/// Author: AFU<br/>
/// Date: 29.10.2025<br/>
/// Copyright ©: EUDT GmbH 2024 <br/>
/// Version-History:<br/>
/// **********************************************************************<br/>
/// *** v1.0.0 - 17.11.2025                                            ***<br/>
/// **********************************************************************<br/>
/// * - generates basic functionality                                    *<br/>
/// **********************************************************************<br/>
jQuery.widget("bluaul.UserNotificationCenter", jQuery.common.vcBaseV4, {

    myData: {
        entries: null,
        types: null,
        details: null,
    },

    myStatus: {
        showDetails:false,
        uncid: -1,
        bInit: true,
        isAdmin: false,
        dateRange: { from: moment().add(-7, "days").format('DD.MM.YYYY'), to: moment().format('DD.MM.YYYY') },
        listHeight: -1,
    },
    _create: function () {
        this._createVisual(398);
        this._super();
    },
    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".vc-user-notification-center");

            me.myData.types = JSON.parse(me.specific.lstTypes);
            me.myData.projects = JSON.parse(me.specific.lstProjects);

            me.myStatus.uncid = typeof (me.options.parameter.UncId) === 'undefined' ? -1 : me.options.parameter.UncId;

            //get the default time range
            me.myStatus.dateRange.from = moment().add(me.specific.interval * -1, "days").format('DD.MM.YYYY');

            me._buildHtml();
            me._setHeightsAndWidths();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _initEvents: function () {
        var me = this;
        try {

            // initialize the date and task box
            me._initStructure();

            me._fetch();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure
        /// </summary>
        var me = this;
        try {
            me.myHtml = {
                topMenu: {}, filter: {}, list: {}
            };

            //top menu 
            obj = me.myHtml.topMenu;
            obj.wrapper = me._setWrapper("top-menu", "vc-grid-margin-bottom");
            obj.reload = me._setMainButton("reload", me.specific.resources.iconReload, me.specific.resources.reload).addClass("active");
            obj.date = me._setObj("date", "optionbox vc-grid-2col vc-grid-margin-right  float-box");
            obj.types = me._setObj("types", "optionbox vc-grid-2col vc-grid-margin-right  float-box");
            obj.projects = me._setObj("types", "optionbox vc-grid-2col vc-grid-margin-right  float-box");
            obj.showAll = me._setObj("user", "optionbox vc-grid-2col float-box");


            obj.ddlTypes = $("<select>").attr("id", "ddl-types").css("width", "100%").css("padding", "3px 0 4px 0").addClass("ddl");
            obj.ddlTypes.append($("<option>", { value: -1, text: me.specific.resources.selectAll }));
            $.each(me.myData.types, function () { obj.ddlTypes.append($("<option>", { value: this.Key, text: this.Value })); });
            obj.types.vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.filter, clickable: true, isList: true, content: obj.ddlTypes }]
            });

            //project list
            obj.ddlProjects = $("<select>").attr("id", "ddl-projects").css("width", "100%").css("padding", "3px 0 4px 0").addClass("ddl");
            obj.ddlProjects.append($("<option>", { value: -1, text: me.specific.resources.selectAll }));
            $.each(me.myData.projects, function () { obj.ddlProjects.append($("<option>", { value: this.Key, text: this.Value })); });


            obj.ddlProjects.val(me.settings.blid);
            obj.projects.vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.projects, clickable: true, isList: true, content: obj.ddlProjects }]
            });
            //we hide the dropdown if we only have one project
            if (me.myData.projects.length == 1) { obj.projects.hide(); }


            let divShowAll = me._setObj("", "vc-").css("margin-top", "16px");
            obj.chbShowAll = me._setInput("chb-show-all", "").attr("type", "checkbox").prop("name", "chb-show-all").css("margin-right", "3px");
            let lblShowAll = $("<label>").attr("for", "chb-show-all").text(me.specific.resources.showAll);
            divShowAll.append(obj.chbShowAll, lblShowAll);
            obj.showAll.vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.users, clickable: true, isList: false, content: divShowAll }]
            });

            //we have the checkbox if we are no admin
            if (!me.specific.isAdmin) { obj.showAll.hide(); }


            obj.wrapper.append(obj.reload, obj.date, obj.types, obj.projects, obj.showAll);


            obj = me.myHtml.filter;
            obj.wrapper = me._setWrapper("", "");
            obj.filter = me._setObj("filter", "vc-filter vc-grid-2col float-box");
            obj.wrapper.append(obj.filter);


            //signal list
            obj = me.myHtml.list;
            obj.wrapper = me._setWrapper("", "vc-list ").css("border", "1px solid #ddd");
            obj.header = me._setListHeader("");
            // generate header list
            var line = me._setListItem();
            line.column.append(me._setListElement("", "w5").css("text-align", "center").html(me.specific.resources.unread));
            line.column.append(me._setListElement("", "w10").css("text-align", "center").html(me.specific.resources.date));
            line.column.append(me._setListElement("", "w10").html(me.specific.resources.recipient));
            line.column.append(me._setListElement("", "w15").html(me.specific.resources.project));
            line.column.append(me._setListElement("", "w10").html(me.specific.resources.type));
            line.column.append(me._setListElement("", "w50").html(me.specific.resources.subject));
            
          
            obj.header.append(line.item);
            obj.entries = me._setObj("entries", "vc-list-table");
            obj.details = {};
            obj.details.wrapper = me._setWrapper("", "details vc-grid-margin-top").hide();
            obj.details.email = me._setObj("details-email", "vc-grid-1col button-toggle button-toggle-active").data("type", "email").html(me.specific.resources.content);
            obj.details.edit = me._setObj("details-edit", "vc-grid-1col  button-toggle ").data("type", "edit").html(me.specific.resources.editation);
            obj.details.content = me._setObj("details-edit-content", "").css("padding", "12px").css("border", "1px solid #ddd");

            obj.details.wrapper.append(obj.details.email, obj.details.edit, obj.details.content);


            obj.wrapper.append(obj.header, obj.entries, obj.details.wrapper);

            me.myRoot.append(me.myHtml.topMenu.wrapper, me.myHtml.filter.wrapper, me.myHtml.list.wrapper);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {

            //init vcDate
            me.myHtml.topMenu.date.vcDateBox({ mode: "Range", align: "center", interval: 1, langID: me.settings.userLangIDForCulture, defaultRange: me.myStatus.dateRange, callback: function (obj) { me.myStatus.dateRange = obj.dateRange; } });

            //init buttons
            me.myHtml.topMenu.reload.off("click").on("click", function () { me._fetch(); });

            //init vc-filter
            me.myHtml.filter.filter.vcFilter({ callback: function () { me._filter(); } });

            //init commit state icon 
            me.myHtml.list.entries.off("click", '.vc-list-item .chb-unread').on("click", '.vc-list-item .chb-unread', function (e) {
                me._upateChecked($(e.target));
                e.stopPropagation();
            });

            //init list detail event
            me.myHtml.list.entries.off("click", '.vc-list-item').on("click", '.vc-list-item', function (e) {
                me.myHtml.list.entries.find('.vc-list-item').removeClass("selected");
                let item = $(e.target);
                if (!item.hasClass("vc-list-item")) item = $(e.target).parents(".vc-list-item");
                item.addClass("selected");
                me.myStatus.uncid = item.data("id");
                me._fetchDetails();
            });

           //initdetails content buttons
            me.myHtml.list.details.wrapper.find(".button-toggle").off("click").on("click", function (e) {
                me._showDetailContent($(this));
            }).button();

        } catch (e) { me._writeErr(e); }
    },
    _fetch: function () {
        /// <summary>
        /// This function fetches the data based on the current setings
        /// </summary>
        var me = this;
        try {

            me._toggleDetails(false);

            me._setLoadingIcon(me.myHtml.list.entries);
            var param = { TypeId: 1, LoggerId: me.myHtml.topMenu.ddlProjects.val(), StartDate: me.myStatus.dateRange.from, EndDate: me.myStatus.dateRange.to, UncTypeId: me.myHtml.topMenu.ddlTypes.val(), ShowAllUser: me.myHtml.topMenu.chbShowAll.prop("checked") }
            me.getData(param, function (result) {

                //check response content
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true); // TODO
                    return true;
                }
                me.myData.entries = result;

                me._generateList();

                //check the first time we load entries if we find the given unc id
                if (me.myStatus.uncid != -1 && me.myStatus.bInit) {

                    if (me.myHtml.list.entries.find(".selected").length == 0) {
                        me.openInfoDialog(me.specific.resources.noEntryFound, { at: 'center center-20%', of: window });
                        me.myStatus.uncid = -1;
                    }
                    me.myStatus.bInit = false;
                };
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _generateList: function () {
        /// <summary>
        /// This function generates a list from the data
        /// </summary>
        var me = this;

        try {

            if (me.myData.entries.length == 0) {
                me.myHtml.list.entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                me.myStatus.uncid = -1;
                return false;
            }

            //clear list
            me.myHtml.list.entries.html("");

            // fill entry list
            $.each(me.myData.entries, function (key, row) {
                me.myHtml.list.entries.append(me._fillRow(row));
            });

            me._filter();



            return true;

        } catch (e) { me._writeErr(e); return false; }
    },
    _fillRow: function (row) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {

            var line = me._setListItem();
            line.item.data("id", row.Id);

            if (me.myStatus.uncid == row.Id) { line.item.addClass("selected") };

            let chkUnread = "";
            if (row.CommitDate == null) {
                if (!row.Read) {
                    line.item.addClass("unread");
                    chkUnread = me._setInput("", "chb-unread").attr("type", "checkbox").prop("name", "chb-unread");
                }
            }

            line.column.append(me._setListElement("", "w5").css("text-align", "center").html(chkUnread).append($("<br>")));
            line.column.append(me._setListElement("", "w10").css("text-align", "center").html(moment(row.Timestamp, "DD.MM.YYYY HH:mm").format("DD.MM.YYYY HH:mm:ss") ));
            line.column.append(me._setListElement("", "w10").html(row.User));
            line.column.append(me._setListElement("", "w15").html(row.Project.length > 0 ? row.Project : "-"));
            line.column.append(me._setListElement("", "w10").html(me.myData.types.find(x => x.Key === row.TypeId).Value));
            line.column.append(me._setListElement("", "w50").html(row.Subject));
            
         
            return line.item;
        } catch (e) { me._writeErr(e); return false; }
    },
    _toggleDetails: function (bShow) {
        /// <summary>
        /// This function toggles between details and list view
        /// </summary>
        var me = this;
        try {

            if (bShow) { 
                me.myHtml.list.entries.find(".vc-list-item").hide();
                var item = me.myHtml.list.entries.find(".vc-list-item.selected");
                item.show();
                me.myHtml.list.entries.height(item.outerHeight()-2);
                me.myHtml.list.details.email.hide();
                me.myHtml.list.details.edit.hide();
                me.myHtml.list.details.wrapper.show().height(me.myStatus.listHeight - item.outerHeight() + 2);
                me.myHtml.list.details.content.height(me.myHtml.list.details.wrapper.height() - 42);
                me.myStatus.showDetails = true;
            } else {
                me.myHtml.list.details.wrapper.hide();
                me.myHtml.list.entries.height(me.myStatus.listHeight);
                me._filter();
                me.myStatus.showDetails = false;
            }


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _fetchDetails: function () {
        /// <summary>
        /// This function fetches the details for one single note
        /// </summary>
        var me = this;
        try {
            var bShow = !me.myStatus.showDetails;

            me._toggleDetails(bShow);

            if (bShow) {
                me._setLoadingIcon(me.myHtml.list.details.content);
                var param = { TypeId: 2, UncId: me.myStatus.uncid }
                me.getData(param, function (result) {

                    //check response content
                    if (result == null) {
                        me.showMessage(me.resources.err_loadData, true); // TODO
                        return true;
                    }
                    me.myData.details = result;


                    me.myHtml.list.details.content.html(me.myData.details.Body);
                    //stop if we do not need a sub widget
                    if (me.myData.details.NoteData.length > 0) {
                        me.myHtml.list.details.email.show();
                        me.myHtml.list.details.edit.show();

                        me.myHtml.list.details.email.removeClass("button-toggle-active").addClass("button-toggle-active");
                        me.myHtml.list.details.edit.removeClass("button-toggle-active");
                        return true;
                    }


                });
            } 

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    //ADD SUBVISUAL CONTENT HERE
    _showDetailContent: function (obj) {
        /// <summary>
        /// This function shows the content of one single note
        /// </summary>
        var me = this;
        try {
            
            if (obj.hasClass("button-toggle-active")) return ;
            //switch toggle state
            me.myHtml.list.details.wrapper.find(".button-toggle").removeClass("button-toggle-active");
            obj.addClass("button-toggle-active");

            if (obj.data("type") == "email") {
                me.myHtml.list.details.content.html(me.myData.details.Body);
                return;
            }


            //show the content for the different note types
            switch (me.myData.details.TypeId) {
                case 1: //data center email validation
                    var subId = JSON.parse(me.myData.details.NoteData);
                    //console.info(subId);
                    //console.info(me.myData.details);

                    me.myHtml.list.details.content.DcValidationEmailList({ invokeType: "addVisualContent", parameter: { LoggerId: me.settings.blid, EmailHash: subId} });

                    break;


                default:
            }




        } catch (e) { me._writeErr(e);  }
    },
    _upateChecked: function (obj) {
        /// <summary>
        /// This function fetches the data based on the current setings
        /// </summary>
        var me = this;
        try {

            let item = obj.parents(".vc-list-item");
            obj.hide();
            var param = { TypeId: 1, UncId: item.data("id") }
            me.updateData(param, function (result) {

            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {

            let h = me._getVisualHeight();
            me.myHtml.list.wrapper.css("height", h - me.myHtml.topMenu.wrapper.outerHeight() - me.myHtml.filter.wrapper.outerHeight() - 25);

            //set height of main  list
            me.myStatus.listHeight = parseInt(h - me.myHtml.topMenu.wrapper.outerHeight() - me.myHtml.filter.wrapper.outerHeight() - me.myHtml.list.header.outerHeight() - 25); 
            me.myHtml.list.entries.css("height", me.myStatus.listHeight).css("maxHeight", me.myStatus.listHeight);

        } catch (e) { me._writeErr(e); }
    },

    _filter: function () {
        this._doListTableFilter(this.myHtml.list.entries);
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {

                me.myHtml.topMenu.hide();
                me.myHtml.list.hide();
            }
            return true;
        } catch (e) {
            me.writeError(e); return false;
        }
    },


    //REMOVE AFTER DEV
    writeError: function (source, ex) {
        var me = this;
        try {

            console.info(ex);
       
            return false;
        } catch (ex) {
            me.error = true;
            writeError(me.source + '.JS.writeError', ex);
            return false;
        }
    },


});